/* eslint-disable @next/next/no-img-element */
import React from 'react';
import { IEntryLine } from 'types/Draws';
import { stringFromDate } from 'utils/common';
import { ASSET_PREFIX, colors } from 'utils/constants';
import Chevron from './Chevron';
import WeeklyDrawLine from './WeeklyDrawLine';

export const PendingEntriesSection = ({
  entries,
  asIcon,
  estimatedRenewalDate,
}: {
  entries: IEntryLine[]|null;
  asIcon: boolean;
  estimatedRenewalDate?: Date;
}) => {
  const [expanded, setExpanded] = React.useState(false);
  if (!entries) return null;
  return (
    <div
      style={{ background: '#e1e1e1' }}
      className="rounded-lg w-full p-5 hover:cursor-pointer "
      onClick={() => setExpanded(!expanded)}
    >
      {
        <div className="flex justify-between">
          <div className="flex p-2">
            <div className="mr-4 flex items-center">
              <img src={`${ASSET_PREFIX}/static/pendingicon.svg`} />
            </div>
            <p className="text-lg font-bold">
              Upcoming Entr{entries.length > 1 ? 'ies' : 'y'}
            </p>
          </div>
          <div className="flex flex-col justify-center content-center">
            <Chevron
              direction={expanded ? 'up' : 'down'}
              reversed={undefined}
              inline={undefined}
              style={undefined}
            />
          </div>
        </div>
      }
      {expanded && (
        <div className="w-full p-2">
          <div className="border border-solid mb-5"></div>
          {estimatedRenewalDate && (
            <p className="text-start italic">
             Your new entr{entries.length > 1 ? 'ies' : 'y'} will be used when your subscription renews on{' '}
              <strong>{stringFromDate(estimatedRenewalDate)}</strong>
            </p>
          )}
          {entries.map((entry, i) => {
            return (
              <WeeklyDrawLine
                resultOrEntryLine={entry}
                key={i}
                circleNumbers={asIcon ?? false}
                additionalStylingBonus={
                  asIcon
                    ? `
          border: 2px solid ${colors.primaryBrandGray};
          color: #E1E1E1;
          background-color: ${colors.primaryBrandGray};
        `
                    : undefined
                }
              />
            );
          })}
        </div>
      )}
    </div>
  );
};
